import { render, staticRenderFns } from "./schoolProjectListThree.vue?vue&type=template&id=22041e3f&scoped=true"
import script from "./schoolProjectListThree.vue?vue&type=script&lang=js"
export * from "./schoolProjectListThree.vue?vue&type=script&lang=js"
import style0 from "./schoolProjectListThree.vue?vue&type=style&index=0&id=22041e3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22041e3f",
  null
  
)

export default component.exports